<template>
    <div>
        <div v-if="productList.length">
            <div class="title">推荐产品</div>
        <ul>
            <li v-for="product in productList" :key="product.productId" class="product" @click="clickProduct(product.productId)">
                <div class="image">
                    <img :src="product.faceImagePath" />
                </div>
                <h3>{{product.productName}}</h3>
                <p style="color:#a6a6a6">{{product.productDesc}}</p>
                <p
                    style="color:#FF9000"
                    v-if="product.targetModelCode"
                >{{$options.filters['queryDict']('target', 'length', product.targetModelCode)}}mm*{{$options.filters['queryDict']('target', 'width', product.targetModelCode)}}mm*{{$options.filters['queryDict']('target', 'height', product.targetModelCode)}}mm</p>
                <p
                    style="color:#a6a6a6"
                    v-if="product.targetModelCode"
                >自重{{$options.filters['queryDict']('target', 'weight', product.targetModelCode)}}±{{$options.filters['queryDict']('target', 'weight_deviation', product.targetModelCode)}}kg</p>

                <p>
                    ￥
                    <span style="font-size:25px">{{product.benchmarkPrice}}/</span>个
                </p>
            </li>
        </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {    
        productList: Array
    },
    methods: {
        clickProduct(productId) {
            this.$router.replace({
                path: '/product-details',
                query: { productId }
            });
        },

    }

}
</script>

<style lang="scss" scoped>
.title {
    width: 250px;
    height: 38px;
    background: #f7f7f7;
    color: #666;
    line-height: 38px;
    text-align: center;
    margin: 0 0 10px 0px;
    // border:1px solid #d3d1d1;
    // border-radius: 4px;
    border-bottom: 1px solid #ff9000;
}
.product:last-child {
    border-bottom-color: #d3d1d1;
}
.product {
    width: 250px;
    height: 335px;
    // margin: 10px;
    border: 1px solid #d3d1d1;
    background: #f8f7f7;
    // border-radius: 4px 4px 0 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-bottom-color: transparent;
    h3 {
        margin-top: 10px;
    }
    // p {
    //     margin-top: 5px;
    // }
    .image {
        width: 200px;
        height: 200px;
        img {
            width: 220px;
        }
    }

    p:last-child {
        color: #ff9000;
    }
    // &:hover {
    //     border: 1px solid #ff9000;
    // }
}
</style>